module.exports = __webpack_public_path__ + "static/media/012-Erkundigen_oV_ID_8.c9adc895.mp3";